import * as React from "react";
import type { AppPreviewGalleryInternalProps } from "@1js/acui-gallery";
import type {
  AppIconGalleryButtonProps,
  AppIconPreviewGalleryProps,
} from "@1js/acui-gallery-icon";
import { AppIconPreviewGallery } from "@1js/acui-gallery-icon";
import type { RibbonControlInternalProps } from "../../RibbonControlProps";

export type RibbonIconPreviewGalleryInternalProps = AppIconPreviewGalleryProps &
  AppPreviewGalleryInternalProps<AppIconGalleryButtonProps> &
  RibbonControlInternalProps;

export class RibbonIconPreviewGalleryCurrent extends React.PureComponent<
  RibbonIconPreviewGalleryInternalProps,
  {}
> {
  public render() {
    return (
      <AppIconPreviewGallery
        {...this.props}
        dataAutomationType="RibbonIconPreviewGallery"
        persistMenu={true}
      />
    );
  }
}

export default RibbonIconPreviewGalleryCurrent;
